module.exports = __webpack_public_path__ + "static/media/生日2.75dc76a6.jpeg";